const defaultTheme = require('tailwindcss/defaultTheme');
const plugin = require('tailwindcss/plugin');

const generateColorClass = (variable) => ({ opacityValue }) => (opacityValue ? `rgba(var(--${variable}), ${opacityValue})` : `rgb(var(--${variable}))`);

module.exports = {
  mode: 'jit',
  purge: [
    './public/**/*.html',
    './src/**/*.{js,jsx,ts,tsx,vue}',
    './src/**/**/*.{js,jsx,ts,tsx,vue}',
  ],
  darkMode: false, // or 'media' or 'class'
  variants: {
    extend: {},
  },
  plugins: [
    require('@tailwindcss/aspect-ratio'),
    require('@tailwindcss/forms'),
    require('@tailwindcss/line-clamp'),
    plugin(({ addComponents, addVariant, e }) => {
      addComponents({
        '.default-card-border': {
          'box-shadow': '0px 0px 4px #E8DCD4',
          '&:hover': {
            'box-shadow': '0px 0px 6px #F3DED0',
          },
        },
      });
      addVariant('data-active', ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => `.${e(`data-active${separator}${className}`)}[data-active="true"]`);
      });
    }),

  ],
  theme: {
    extend: {
      colors: {
        black: generateColorClass('black'),
        blue: {
          400: 'var(--blue-400)',
        },
        current: 'currentColor',
        gray: {
          50: 'var(--gray-50)',
          500: 'var(--gray-500)',
          300: 'var(--gray-300)',
        },
        'grass-green': {
          500: 'var(--grass-green-500)',
        },
        green: {
          50: 'var(--green-50)',
          300: 'var(--green-300)',
          500: 'var(--green-500)',
          600: 'var(--green-600)',
          700: 'var(--green-700)',
        },
        'light-gray': {
          500: 'var(--light-gray-500)',
          400: 'var(--light-gray-400)',
        },
        'light-yellow': 'var(--light-yellow)',
        orange: {
          500: 'var(--orange-500)',
          400: 'var(--orange-400)',
          300: 'var(--orange-300)',
          100: 'var(--orange-100)',
          50: 'var(--orange-50)',
        },
        primary: {
          50: 'var(--green-50)',
          300: 'var(--green-300)',
          400: 'var(--green-400)',
          500: 'var(--green-500)',
          600: 'var(--green-600)',
          700: 'var(--green-700)',
        },
        red: {
          50: 'var(--red-50)',
          500: 'var(--red-500)',
          700: 'var(--red-700)',
        },
        secondary: {
          500: 'var(--orange-500)',
          400: 'var(--orange-400)',
          300: 'var(--orange-300)',
          100: 'var(--orange-100)',
          50: 'var(--orange-50)',
        },
        transparent: 'transparent',
        yellow: {
          500: 'var(--yellow-500)',
        },
      },
      fontSize: {
        '3.25xl': ['2rem', '46px'],
        '3.5xl': ['2.125rem', '51px'],
        '4.5xl': ['2.375rem', '57px'],
        ...defaultTheme.fontSize,
      },
      inset: {
        '25.5': '6.375rem',
        ...defaultTheme.inset,
      },
      margin: {
        25: '6.25rem',
      },
      maxHeight: {
        '1/2': '50%',
        'screen-1/2': '50vh',
        'modal-content': '12.375rem',
        ...defaultTheme.maxHeight,
      },
      minHeight: {
        '1/3': '33.33%',
        '1/5': '20%',
        'menu-list-desktop': '152px',
        'menu-list-mobile': '140px',
        'modal-content': '4rem',
        ...defaultTheme.minHeight,
      },
      maxWidth: {
        '1/2': '50%',
        '21.25': '85%',
        ...defaultTheme.maxWidth,
      },
      minWidth: {
        '1/2': '50%',
        ...defaultTheme.minWidth,
      },
      spacing: {
        'cart-sidebar': '448px',
        'menu-sidebar': '285px',
        ...defaultTheme.spacing,
      },
      width: {
        70: '17.5rem',
        100: '25rem',
        'fit': 'fit-content',
        'modal-lg': '650px',
        ...defaultTheme.width,
      },
    },
    screens: {
      ...defaultTheme.screens,
      xs: {
        min: '200px',
        max: '319px',
      },
      sm: {
        min: '320px',
        max: '767px',
      },
      md: {
        min: '768px',
        max: '1099px',
      },
    },
  },
};
